import { useMemo } from 'react';
import { useI18n } from '../../i18n';
import { translateTravel } from '@cubemeet/core/modules/travel/i18n';

export const useTravelI18n = () => {
  const { language } = useI18n();
  const t = useMemo(() => {
    return (key: string, params?: Record<string, any>) => translateTravel(language, key, params);
  }, [language]);

  return { t, language };
};
